<template>
  <div class="home" ref="home" v-show="!isShow.isLDShow">
  </div>
</template>

<script>
import LongImage from '../../LongImg.js'
import { resources } from './data.js'
import { spritesConfig } from './spritesConfig.js';
import { animationsConfig } from './animationConfig';

export default {
  name: 'home',
  props: {
    isShow: Object
  },
  methods: {
    init() {
      this.longImg = new LongImage({
        container: this.$el,
        resource: this.getResource(),
        sprites: this.getSprites(),
        spritesAnimations: this.getSpritesAnimations(),
        texts: this.getTexts(),
        textsAnimations: this.getTextsAnimations(),
        bgSprites: this.getBgSprites(),
        touchOptions: {
          initialValue: 0,
          sensitivity: 0.7,
          maxSpeed: 0.6
        }
      })
      this.longImg.on('loadProgress', (progress) => {
        console.log(`加载进度：${progress}`)
      })
      this.longImg.on('loadDone', () => {
        console.log('加载完毕');
      })
      this.longImg.on('progress', ({progress, val, length}) => {
        console.log(`当前进度：${progress}, val: ${val}, length: ${length}`);
      })
    },
    getResource() {
      const resource = { sprites: resources };
      return resource
    },
    getSprites() {
      const sprites = spritesConfig;
      return sprites;
    },
    getSpritesAnimations() {
      const animations = animationsConfig;
      return animations;
    },
    getTexts() {
      const texts = {};
      return texts;
    },
    getTextsAnimations() {
      const texts = {};
      return texts;
    },
    getBgSprites() {
      const bgSprites = [{
        name: 's1-bg',
      }, {
        name: 's2-bg',
      }, {
        name: 's3-bg',
      }, {
        name: 's4-bg',
      }, {
        name: 's5-bg',
      }, {
        name: 's6-bg',
      }, {
        name: 's7-bg',
      }, {
        name: 's8-bg',
      }, {
        name: 's9-bg',
      }, {
        name: 's10-bg',
      }, {
        name: 's11-bg',
      }, {
        name: 's12-bg',
      }, {
        name: 's13-bg'
      }]
      return bgSprites
    },
  },
  mounted() {
    this.init();
    const img = document.createElement('img');
    img.src = require('./img/qr-group.png');
    img.classList.add('fn-qr');
    if (window.innerWidth > window.innerHeight) {
      img.classList.add('fn-qr-l');
    } else {
      img.classList.add('fn-qr-p')
    }
    this.$refs.home.appendChild(img);
  }
}
</script>

<style lang="less">
.home {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.fn-qr {
  position: absolute;
  transition: transform .4s ease-in 0.5s;
}
.fn-qr-l {
  bottom: 1rem;
  right: 1rem;
  width: 20.38vh;
  height: 87vh;
  transform: translateX(135%);
}

.fn-qr-l__fn {
  transform: translateX(0);
}
.fn-qr-p {
  left: .5rem /* 8/16 */;
  bottom: .5rem /* 8/16 */;
  width: 20.38vw;
  height: 87vw;
  transform-origin: 50% 88%;
  transform: translateY(120%) rotate(90deg);
}

.fn-qr-p__fn {
  transform: translateY(0) rotate(90deg);
}
</style>
